'use client';

import { Button } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { useSelector } from 'react-redux';

import getShipperById from '@/_service/shipper.service';
import { IRedux } from '@/_store/types';

export default function RequestCallbackButton() {
  const t = useTranslations();
  const { data } = useSelector((state: IRedux) => state.settings);

  const { data: shipper, isFetched } = useQuery({
    queryKey: ['shipper-by-id', data?.shipper_id],
    queryFn: () =>
      getShipperById(data?.shipper_id || '').then((res) => res.data),
    enabled: Boolean(data?.shipper_id),
  });

  const phone = shipper?.phone?.[0];
  if (!phone && isFetched) return null;

  return (
    <Button
      asChild
      loading={!isFetched}
      variant='outline'
      rounded={12}
      borderColor='primary'
      color='primary'
      _hover={{ bg: 'primary', color: 'primary.text' }}
    >
      <a href={`tel:${phone}`}>{t('request_callback')}</a>
    </Button>
  );
}
